import { createAsyncThunk } from "@reduxjs/toolkit";
import { deleteDocument, getDocumentList } from "api/docAnalysis";
import { getChatHistoryListByDate, getFirstQuestionList, getUniqueQuestionList, deleteHistoryByDate } from "api/history";
import { uploadDocFileToAnalyze } from '../../api/docAnalysis/index';
import { formAutomate, meetAutomate, notification, generateFromSurveyLinks } from "api/chat";
import {ShareFormSurveyLink} from '../../api/chat/index';

export const getFirstQuestionListThunk = createAsyncThunk(
    "/getFirstQuestionList",
    async (data) => {
        try {
            const response = await getFirstQuestionList(data);
            return response;
        } catch (error) {
            return error;
        }
    }
);

export const getChatHistoryListByDateThunk = createAsyncThunk(
    "/getChatHistoryListByDate",
    async (data) => {
        try {
            const response = await getChatHistoryListByDate(data);
            return {
                date: data.date,
                result: response
            };
        } catch (error) {
            return error;
        }
    }
);

export const getUniqueQuestionListThunk = createAsyncThunk(
    "getUniqueQuestionList",
    async (data) => {
        try {
            const response = await getUniqueQuestionList(data);
            return response;
        } catch (error) {
            return error;
        }
    }
)

export const deleteHistoryByDateThunk = createAsyncThunk(
    "deleteHistoryByDate",
    async (data) => {
        try {
            const response = await deleteHistoryByDate(data);
            return response;
        } catch (error) {
            return error;
        }
    }
)

export const getDocumentListThunk = createAsyncThunk(
    "/getDocumentList",
    async () => {
        try {
            const response = await getDocumentList();
            return response;
        } catch (error) {
            return error;
        }
    }
);

export const deleteDocumentThunk = createAsyncThunk(
    "deleteDocument",
    async (payload) => {
        try {
            const response = await deleteDocument(payload);
            return response;
        } catch (error) {
            return error;
        }
    }
)

export const uploadDocFileToAnalyzeThunk = createAsyncThunk(
    "uploadDocFileToAnalyze",
    async (payload) => {
        try {
            const response = await uploadDocFileToAnalyze(payload);
            return response;
        } catch (error) {
            return error;
        }
    }
)

export const triggerFormAutomateThunk = createAsyncThunk(
    "triggerFormAutomation",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await formAutomate(payload);
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const triggerMeetAutomateThunk = createAsyncThunk(
    "triggerMeetAutomation",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await meetAutomate(payload);
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const getNotificationThunk = createAsyncThunk(
    "chat/getNotification",
    async (_, { rejectWithValue }) => {
        try {
            const response = await notification();
            return response;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const generateFromSurveyLinksThunk = createAsyncThunk(
    "generateFromSurveyLinks",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await generateFromSurveyLinks(payload);
            return response;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);


export const shareFormSurveyLinkThunk = createAsyncThunk(
    "ShareFormSurveyLink",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await ShareFormSurveyLink(payload);
            return response;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);




